import React from "react";

export const ManagePaymentContext = React.createContext({
    parent: null,
});